// extracted by mini-css-extract-plugin
export default {"wrapper":"Tw-z","viewport":"Uw-z","container":"Vw-z","slide":"Ww-z"};